import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { safeJsonParse } from '../../helper/utils/safeJsonParse';
import usePages from '../onlineSales/hooks/usePages';
import AnalyticsTracker from './AnalyticsTracker';

export default function OutletLayoutPage() {
    const { pages } = usePages();

    const params = useParams();
    const navigate = useNavigate();

    const outletId = (params['outletId'] || '').toString().trim().toLowerCase();
    const outlets = safeJsonParse(localStorage.getItem('outlets', []));

    const handleChangeOutlet = () => {
        const outletInStorage = safeJsonParse(localStorage.getItem('outlets'), []);
        const filteredByOutletId = outletInStorage?.filter((outlet) => (outlet['outletName'] || '').toString().trim().toLowerCase() === outletId) || [];
        const outlet = filteredByOutletId.length > 0 ? filteredByOutletId[0] : {};

        if (Object.keys(outlet).length > 0) {
            const filteredPage = pages?.filter((pg) => pg['id'] === outlet['brandCode']);
            const pageData = filteredPage.length > 0 ? { ...filteredPage[0], ...outlet } : {};

            localStorage.setItem('outlet', JSON.stringify(outlet));
            localStorage.setItem('page', JSON.stringify(pageData));
        } else if (pages && pages.length > 0) {
            // Only navigate away if pages are loaded and we still can't find the outlet
            navigate('/');
        }
    };

    useEffect(() => {
        handleChangeOutlet();
    }, [outletId, pages, outlets]);

    return (
        <>
            <AnalyticsTracker />
            <Outlet />
        </>
    );
}
